import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { planTrainingNewParticipant, planTrainingParticipant, planTrainingParticipantCancle, planTrainingParticipantOk } from "../../config/apiSPA";
import SpinnerTable from "../../components/spinner/spinnerTable";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { CardHeader } from "react-bootstrap";
import DetailParticipantResume from "./detailParticipantResume.jsx";
import ModalPlanTrainingParticipant from "../../components/modal/modalPlanTrainingParticipant.jsx";
import ModalInfo from "../../components/modal/modalInfo.jsx";
import ModalEditTextV2 from "../../components/modal/modalEditTextV2.jsx";
const participantPreset = {
  data: [],
};

const generalDataPreset = {
  data: null,
};
function DetailParticipant({ mainId, mainData }) {
  const [contenLoading, setContentLoading] = useState(true);
  const [participants, setParticipants] = useState(participantPreset);
  const [generalData, setGeneralData] = useState(generalDataPreset);
  const [modalAddParticipant, setModalAddParticipant] = useState({ show: false });
  const [modalInfo, setModalInfo] = useState({ show: false, title: "", text: "", theme: "danger" });
  const [modalEditPartStatus, setModalEditPartStatus] = useState({ show: false, id: null, val: false });
  const loadData = async () => {
    try {
      const res = await planTrainingParticipant(mainId);
      setParticipants(res);
      setContentLoading(false);
    } catch (error) {
      setContentLoading(false);
    }
  };
  const handleAddParticipant = () => {
    setModalAddParticipant({ show: true });
  };
  const handleClickSubmitAddParticipant = async (val) => {
    try {
      setModalAddParticipant({ show: false });
      const res = await planTrainingNewParticipant(val);
      setParticipants(res);
    } catch (error) {
      setModalAddParticipant({ show: false });
      setModalInfo({ show: true, title: "Failed", text: `Error message : ${error.message}`, theme: "danger" });
    }
  };
  const handleClickChangeStatus = (id, val) => {
    setModalEditPartStatus({ show: true, id: id, val: val });
  };

  const handleSubmitChangePartStatus = async (val) => {
    setModalEditPartStatus((a) => ({ ...a, show: false }));
    const payload = {
      id: val.id,
      remark: val.data,
    };
    try {
      const res = val.variable ? await planTrainingParticipantOk(payload) : await planTrainingParticipantCancle(payload);
      setParticipants(res);
    } catch (error) {
      setModalInfo({ show: true, title: "Failed !!", text: `Error : ${error.message}`, theme: "danger" });
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    setGeneralData(mainData);
  }, [mainData]);
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Participant</CardHeader>
        <CardBody>
          {generalData.data ? <DetailParticipantResume data={generalData.data} /> : ""}

          <div className="table-responsive mb-3">
            <table className="table table-hover text-nowrap">
              <thead>
                <tr>
                  <th className="border-top-0 pt-0 pb-2">No.</th>
                  <th className="border-top-0 pt-0 pb-2">Name</th>
                  <th className="border-top-0 pt-0 pb-2">Position</th>
                  <th className="border-top-0 pt-0 pb-2">Status</th>
                  <th className="border-top-0 pt-0 pb-2">Remark</th>
                  <th className="border-top-0 pt-0 pb-2"></th>
                </tr>
              </thead>
              <tbody>
                {contenLoading ? (
                  <SpinnerTable colSpan={6} />
                ) : participants.data.length > 0 ? (
                  participants.data.map((peserta, index) => (
                    <tr key={index}>
                      <td className="align-middle">{index + 1}</td>
                      <td className="align-middle">
                        <Link to={"/manpower/detail/" + peserta.partData.id}>{peserta.partData.nama}</Link>
                      </td>
                      <td className="align-middle">{peserta.partData.jabatanFn}</td>
                      <td className="align-middle">
                        <div className="form-check form-switch">
                          <input onChange={(val) => handleClickChangeStatus(peserta.id, val.target.checked)} type="checkbox" className="form-check-input" checked={peserta.status !== "OK" ? false : true} />
                          <label className={peserta.status !== "OK" ? "form-check-label text-danger" : "form-check-label"}>{peserta.status}</label>
                        </div>
                      </td>
                      <td className="align-middle">{peserta.remark}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6}> No Data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="mb-2">
            <div className="d-block d-lg-flex align-items-center">
              <span onClick={handleAddParticipant} className="btn btn-outline-theme me-2 mb-1">
                <i className="fa fa-fw fa-plus"></i>
                <span>Add Part..</span>
              </span>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* ===== Modal Add Participant  */}
      <ModalPlanTrainingParticipant show={modalAddParticipant.show} id={mainId} submitClick={handleClickSubmitAddParticipant} onHide={() => setModalAddParticipant((a) => ({ ...a, show: false }))} />
      {/* ===== Modal Add Participant  */}
      {/* =====  */}
      {/* ===== Modal Info  */}
      <ModalInfo show={modalInfo.show} onHide={() => setModalInfo((a) => ({ ...a, show: false }))} title={modalInfo.title} text={modalInfo.text} theme={modalInfo.theme} clicked={() => setModalInfo((a) => ({ ...a, show: false }))} />
      {/* ===== Modal Info  */}
      {/* =====  */}
      {/* ===== Modal Edit Participant Status  */}
      <ModalEditTextV2
        show={modalEditPartStatus.show}
        onHide={() => setModalEditPartStatus((a) => ({ ...a, show: false }))}
        submitClick={handleSubmitChangePartStatus}
        id={modalEditPartStatus.id}
        variable={modalEditPartStatus.val}
        title={"Change Participant Status"}
        text={"Please fill reason why participant status changed"}
      />
      {/* ===== Modal Edit Participant Status  */}
      {/* =====  */}
    </>
  );
}

export default DetailParticipant;
